import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "contact-info__header"
}
const _hoisted_2 = { class: "contact-info__header-left" }
const _hoisted_3 = { class: "contact-info__field" }
const _hoisted_4 = { class: "contact-info__field-name" }
const _hoisted_5 = { class: "contact-info__field-value" }
const _hoisted_6 = { class: "contact-info__field" }
const _hoisted_7 = { class: "contact-info__field-name" }
const _hoisted_8 = { class: "contact-info__field-value" }
const _hoisted_9 = { class: "contact-info__field" }
const _hoisted_10 = { class: "contact-info__field-name" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "contact-info__field" }
const _hoisted_13 = { class: "contact-info__field-name" }
const _hoisted_14 = { class: "contact-info__field-value" }
const _hoisted_15 = { class: "contact-info__field" }
const _hoisted_16 = { class: "contact-info__field-name" }
const _hoisted_17 = { class: "contact-info__field-value" }
const _hoisted_18 = { class: "contact-info__field" }
const _hoisted_19 = { class: "contact-info__field-name" }
const _hoisted_20 = { class: "contact-info__field-value" }
const _hoisted_21 = {
  key: 0,
  class: "contact-info__field contact-info__field--col"
}
const _hoisted_22 = {
  class: "contact-info__field-name",
  style: { color: '#4D4D4D' }
}
const _hoisted_23 = { class: "contact-info__field-value-col-time" }
const _hoisted_24 = { class: "contact-info__field-value-col-name" }
const _hoisted_25 = { class: "contact-info__field-value-col-action" }
const _hoisted_26 = {
  key: 1,
  class: "contact-info__field contact-info__field--col"
}
const _hoisted_27 = {
  class: "contact-info__field-name",
  style: { color: '#4D4D4D' }
}
const _hoisted_28 = {
  key: 2,
  class: "contact-info__field contact-info__field--col"
}
const _hoisted_29 = {
  class: "contact-info__field-name",
  style: { color: '#4D4D4D' }
}
const _hoisted_30 = { class: "contact-info__header-right" }
const _hoisted_31 = { class: "contact-info__add-lists" }
const _hoisted_32 = { class: "contact-info__add-lists-text" }
const _hoisted_33 = { class: "contact-info__lists" }
const _hoisted_34 = { class: "contact-info__lists-item-name" }

import BaseModal from "@/components/common/modal/BaseModal.vue";
import { computed, ref, watch } from "vue";
import { i18n } from "@/i18n";
import { PersonApi } from "@/ api/PersonApi";
import { AnalyticsListItem, ChangelogItem, ClientInfo } from "@/store/clients";
import moment from "moment";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import { AnalyticsApi } from "@/ api/AnalyticsApi";
import AppResizableDropdown from "@/components/ui-kit/dropdown/AppResizableDropdown.vue";
import AppTooltip from "@/components/ui-kit/tooltip/AppTooltip.vue";
import MainInfoListSelect from "../../listSelect/MainInfoListSelect.vue";
import { useModalEscape } from "@/composables/useModalEscape";


export default /*@__PURE__*/_defineComponent({
  __name: 'ContactInfoModal',
  setup(__props, { expose: __expose }) {

const changeDescriptionKeys: Record<string, string> = {
  AddressChanged: "contact_change_address",
  ClientsChanged: "contact_change_clients",
  ContactsChanged: "contact_change_contacts",
  NameChanged: "contact_change_name",
  PostChanged: "contact_change_post",
  TagsChanged: "contact_change_tags",
};

const $modal = ref<typeof BaseModal | null>(null);
const isLoading = ref(false);
const $content = ref<HTMLElement | null>(null);
const clientInfo = ref<ClientInfo | null>(null);
const showAllChanges = ref(false);
const showAddListSelect = ref(false);
const lists = ref<AnalyticsListItem[]>([]);
const selectedList = ref<AnalyticsListItem | null>(null);
const listsNotFound = ref(false);
const $createEditFileModal = ref<typeof AppResizableDropdown | null>(null);

const closeAddClientDropdown = () => {
  showAddListSelect.value = false;
  $createEditFileModal.value?.close();
};

const updateAnalyticLists = async () => {
  if (!clientInfo.value) return;

  clientInfo.value.AnalyticsLists = (
    await AnalyticsApi.getListOfElement(clientInfo.value.Id, 3)
  ).Lists;
};

const tagsString = computed(() => {
  if (!clientInfo.value || !clientInfo.value.Tags) {
    return "";
  }

  return clientInfo.value.Tags.map((tag) => `#${tag}`).join(", ");
});

const mappedLists = computed(() =>
  lists.value.map((list) => ({
    label: list.Name,
    value: list.Id,
    list,
  })),
);

const createDate = computed(() => {
  if (!clientInfo.value || !clientInfo.value.CreateTime) {
    return "";
  }

  return `${moment(clientInfo.value.CreateTime).format("HH:mm DD.MM.YYYY")}${
    clientInfo.value.Creator ? ` (${clientInfo.value.Creator})` : ""
  }`;
});

const getDate = (date: string) => {
  return moment(date).format("HH:mm DD.MM.YYYY");
};

const getChangeDescription = (change: ChangelogItem) => {
  const changedFieldEntry = Object.entries(change).filter(
    (entry) => typeof entry[1] === "boolean" && entry[1],
  );
  return changedFieldEntry.length
    ? String(i18n.global.t(changeDescriptionKeys[changedFieldEntry[0][0] as string]))
    : "";
};

const onDeleteList = async (list: AnalyticsListItem) => {
  if (!clientInfo.value) return;
  await AnalyticsApi.removeElementIntoList(list.Id, 4, clientInfo?.value?.Id);
  clientInfo.value.AnalyticsLists.splice(
    clientInfo.value?.AnalyticsLists.findIndex(
      (listFile) => listFile.Id === list.Id,
    ),
    1,
  );
};

const { activate: activateEsc, deactivate: deactivateEsc } = useModalEscape({
  content: $content,
  close: () => $modal.value?.onClose(),
  intercept: () => {
    if (!showAddListSelect.value) {
      return false;
    }
    closeAddClientDropdown();
    return true;
  }
});

const onOpen = async (Id: number) => {
  try {
    isLoading.value = true;
    $modal.value?.onOpen();
    activateEsc();
    clientInfo.value = await PersonApi.getClientInfo(Id);
  } catch (e) {
    console.error(e);
  } finally {
    isLoading.value = false;
  }
};


const onBaseModalClose = () => {
  deactivateEsc();
  closeAddClientDropdown();
};

watch(showAddListSelect, async (newVal) => {
  if (!newVal) {
    return;
  }

  const list = await AnalyticsApi.getLists(
    "",
    0,
    3,
    clientInfo.value?.Id as number,
  );

  lists.value = list.Lists;
});

watch(selectedList, (newVal) => {
  console.log(newVal);
});

__expose({ onOpen });

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(BaseModal, {
    ref_key: "$modal",
    ref: $modal,
    loading: isLoading.value,
    "fullscreen-on-mobile": "",
    onOnClose: onBaseModalClose
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        ref_key: "$content",
        ref: $content,
        class: "contact-info"
      }, [
        (!isLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('name_short')) + ": ", 1),
                  _createElementVNode("span", _hoisted_5, _toDisplayString(clientInfo.value.Name), 1)
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('position')) + ": ", 1),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(clientInfo.value.Post), 1)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('contact_info')) + ": ", 1),
                  _createElementVNode("span", {
                    class: "contact-info__field-value",
                    innerHTML: clientInfo.value.Contacts
                  }, null, 8, _hoisted_11)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('address_upcase')) + ": ", 1),
                  _createElementVNode("span", _hoisted_14, _toDisplayString(clientInfo.value.Address?.join(", ") || ""), 1)
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('tags_upcase')) + ": ", 1),
                  _createElementVNode("span", _hoisted_17, _toDisplayString(tagsString.value), 1)
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t('created_label')) + ": ", 1),
                  _createElementVNode("span", _hoisted_20, _toDisplayString(createDate.value), 1)
                ]),
                (clientInfo.value.Changelog?.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('changed_label')) + ": ", 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(showAllChanges.value
                ? clientInfo.value.Changelog
                : clientInfo.value.Changelog.slice(0, 4), (change, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "contact-info__field-value-col",
                          key: change.Time
                        }, [
                          _createElementVNode("span", _hoisted_23, _toDisplayString(getDate(change.Time)) + " ", 1),
                          _createElementVNode("span", _hoisted_24, "(" + _toDisplayString(change.Worker) + ")", 1),
                          _createElementVNode("span", _hoisted_25, _toDisplayString(getChangeDescription(change)), 1),
                          (
                  !showAllChanges.value &&
                  clientInfo.value.Changelog.length > 4 &&
                  index === 3
                )
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "contact-info__field-value-col-show-more",
                                onClick: _cache[0] || (_cache[0] = ($event: any) => (showAllChanges.value = true))
                              }, _toDisplayString(_ctx.$t('more_count_label', { count: clientInfo.value.Changelog.length - 4 })), 1))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (clientInfo.value.ConnectedClients?.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t('clients_label')) + ": ", 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(clientInfo.value.ConnectedClients, (client) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "contact-info__field-value-col",
                          key: client.Id
                        }, [
                          _createVNode(_component_router_link, {
                            class: "contact-info__field-value-col-link",
                            to: { query: { page: 'client', id: client.Id } },
                            onClick: _cache[1] || (_cache[1] = ($event: any) => ($modal.value?.onClose()))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(client.Name), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (clientInfo.value.ConnectedProjects?.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.$t('contact_attached_projects')) + ": ", 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(clientInfo.value.ConnectedProjects, (project) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "contact-info__field-value-col",
                          key: project.Id
                        }, [
                          _createVNode(_component_router_link, {
                            class: "contact-info__field-value-col-link",
                            to: { query: { page: 'project', id: project.Id } },
                            onClick: _cache[2] || (_cache[2] = ($event: any) => ($modal.value?.onClose()))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(project.Name), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createVNode(AppResizableDropdown, {
                    position: "left",
                    resizable: false,
                    "initial-width": 320,
                    "initial-height": 436,
                    "close-by-click-outside": false,
                    ref_key: "$createEditFileModal",
                    ref: $createEditFileModal,
                    name: "$createFileModal"
                  }, {
                    activator: _withCtx(() => [
                      _createVNode(AppTooltip, {
                        text: _ctx.$t('add_to_list')
                      }, {
                        activator: _withCtx(() => [
                          _createVNode(AppIcon, {
                            class: "contact-info__add-lists-btn",
                            name: "plus",
                            width: "14px",
                            color: "#979797",
                            "hover-color": "#499259",
                            cursor: "pointer",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (showAddListSelect.value = true))
                          })
                        ]),
                        _: 1
                      }, 8, ["text"])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(MainInfoListSelect, {
                        id: clientInfo.value?.Id,
                        "added-lists": clientInfo.value?.AnalyticsLists,
                        "show-close-icon": "",
                        "entity-type": 3,
                        onClose: closeAddClientDropdown,
                        onAddList: updateAnalyticLists
                      }, null, 8, ["id", "added-lists"])
                    ]),
                    _: 1
                  }, 512),
                  _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.$t('file_info_lists')) + ":", 1)
                ]),
                _createElementVNode("div", _hoisted_33, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(clientInfo.value?.AnalyticsLists, (list) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "contact-info__lists-item",
                      key: list.Id
                    }, [
                      _createElementVNode("div", _hoisted_34, _toDisplayString(list.Name), 1),
                      _createVNode(AppIcon, {
                        class: "contact-info__lists-item-delete",
                        name: "close",
                        width: "12px",
                        color: "#D2D2D2",
                        "hover-color": "#499259",
                        cursor: "pointer",
                        onClick: ($event: any) => (onDeleteList(list))
                      }, null, 8, ["onClick"])
                    ]))
                  }), 128))
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ], 512)
    ]),
    _: 1
  }, 8, ["loading"]))
}
}

})